"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Sign Internal OpenAPI
 * Sign Internal OpenAPI spec
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlagsToJSON = exports.FlagsFromJSONTyped = exports.FlagsFromJSON = exports.instanceOfFlags = exports.FlagsRequestTypeEnum = exports.attributeTypeMapFlags = void 0;
var Integration_1 = require("./Integration");
var UploadIntegrations_1 = require("./UploadIntegrations");
var Charges_1 = require("./Charges");
exports.attributeTypeMapFlags = [
    {
        name: "requestType",
        type: "number",
    },
    {
        name: "allowTemplateDelete",
        type: "boolean",
    },
    {
        name: "allowCreateEditTemplate",
        type: "boolean",
    },
    {
        name: "allowTemplatePreview",
        type: "boolean",
    },
    {
        name: "allowOptionalTemplateSigners",
        type: "boolean",
    },
    {
        name: "smsAuthLeft",
        type: "number",
    },
    {
        name: "hideProgressStepper",
        type: "boolean",
    },
    {
        name: "hideStepperContainer",
        type: "boolean",
    },
    {
        name: "allowIntegrationsUpload",
        type: "boolean",
    },
    {
        name: "allowRecipientAccessCodes",
        type: "boolean",
    },
    {
        name: "allowRecipientSmsAuthNumbers",
        type: "boolean",
    },
    {
        name: "allowRecipientAttachments",
        type: "boolean",
    },
    {
        name: "allowRecipientReassignment",
        type: "boolean",
    },
    {
        name: "forceSignerRoles",
        type: "boolean",
    },
    {
        name: "forceSubjectMessage",
        type: "boolean",
    },
    {
        name: "isAtTemplateLimit",
        type: "boolean",
    },
    {
        name: "maxTemplateNumber",
        type: "number",
    },
    {
        name: "isAtDocumentLimit",
        type: "boolean",
    },
    {
        name: "noMultiFaxes",
        type: "boolean",
    },
    {
        name: "isHelloFax",
        type: "boolean",
    },
    {
        name: "isEditTemplate",
        type: "boolean",
    },
    {
        name: "isResend",
        type: "boolean",
    },
    {
        name: "hasTemplateReuseWarning",
        type: "boolean",
    },
    {
        name: "requireSignerInfo",
        type: "boolean",
    },
    {
        name: "alwaysSendMeACopy",
        type: "boolean",
    },
    {
        name: "alwaysSendOthersACopy",
        type: "boolean",
    },
    {
        name: "integration",
        type: "Integration",
    },
    {
        name: "charge",
        type: "Charges",
    },
    {
        name: "uploadIntegrations",
        type: "UploadIntegrations",
    },
    {
        name: "lockDocumentTitle",
        type: "boolean",
    },
    {
        name: "lockDocumentMessage",
        type: "boolean",
    },
    {
        name: "blockCC",
        type: "boolean",
    },
    {
        name: "allowUnlimitedSelfSign",
        type: "boolean",
    },
    {
        name: "allowExpiresAt",
        type: "boolean",
    },
    {
        name: "allowSmsAuth",
        type: "boolean",
    },
    {
        name: "allowBulkSend",
        type: "boolean",
    },
    {
        name: "allowQualifiedSignature",
        type: "boolean",
    },
    {
        name: "allowNom151",
        type: "boolean",
    },
    {
        name: "canAccessRecipientAccessCodes",
        type: "boolean",
    },
    {
        name: "hasHipaa",
        type: "boolean",
    },
    {
        name: "allowSmsSignatureDelivery",
        type: "boolean",
    },
    {
        name: "isSmsToolsOn",
        type: "boolean",
    },
    {
        name: "canUpgradeTierSmsSignatureDelivery",
        type: "boolean",
    },
    {
        name: "isNewHsPlan",
        type: "boolean",
    },
    {
        name: "isTransactionalPlan",
        type: "boolean",
    },
    {
        name: "displayDocToTemplateBanner",
        type: "boolean",
    },
    {
        name: "shouldConvertDocToTemplate",
        type: "boolean",
    },
    {
        name: "canUseDataValidation",
        type: "boolean",
    },
    {
        name: "canUseCustomRegexDataValidation",
        type: "boolean",
    },
    {
        name: "isApiUser",
        type: "boolean",
    },
    {
        name: "needsCharge",
        type: "boolean",
    },
    {
        name: "chargeType",
        type: "string",
    },
    {
        name: "totalPriceInCents",
        type: "number",
    },
    {
        name: "freeFaxPagesLeft",
        type: "number",
    },
    {
        name: "faxPageCurrentCount",
        type: "number",
    },
    {
        name: "overageFaxMaxLimitInCents",
        type: "number",
    },
    {
        name: "pricePerFaxInCents",
        type: "number",
    },
    {
        name: "initialPageLimit",
        type: "number",
    },
    {
        name: "overagePriceInCentsPerPage",
        type: "number",
    },
    {
        name: "internationalMultiplier",
        type: "number",
    },
    {
        name: "templateConversionCandidateId",
        type: "string",
    },
    {
        name: "shouldTemplateCreateShow",
        type: "boolean",
    },
    {
        name: "isFromFax",
        type: "boolean",
    },
    {
        name: "disableExternalSignature",
        type: "boolean",
    },
    {
        name: "shouldSendFaxPdfs",
        type: "boolean",
    },
    {
        name: "templateGalleryId",
        type: "number",
    },
    {
        name: "apiIdsEnabled",
        type: "boolean",
    },
    {
        name: "canAccessEditAndResendUI",
        type: "boolean",
    },
];
/**
 * @export
 */
exports.FlagsRequestTypeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6,
    NUMBER_7: 7,
    NUMBER_8: 8,
    NUMBER_9: 9,
    NUMBER_10: 10,
    NUMBER_11: 11,
    NUMBER_12: 12,
    NUMBER_13: 13,
    NUMBER_14: 14,
};
/**
 * Check if a given object implements the Flags interface.
 */
function instanceOfFlags(value) {
    if (!("requestType" in value) || value["requestType"] === undefined)
        return false;
    if (!("allowTemplateDelete" in value) ||
        value["allowTemplateDelete"] === undefined)
        return false;
    if (!("allowCreateEditTemplate" in value) ||
        value["allowCreateEditTemplate"] === undefined)
        return false;
    if (!("allowTemplatePreview" in value) ||
        value["allowTemplatePreview"] === undefined)
        return false;
    if (!("allowOptionalTemplateSigners" in value) ||
        value["allowOptionalTemplateSigners"] === undefined)
        return false;
    if (!("smsAuthLeft" in value) || value["smsAuthLeft"] === undefined)
        return false;
    return true;
}
exports.instanceOfFlags = instanceOfFlags;
function FlagsFromJSON(json) {
    return FlagsFromJSONTyped(json, false);
}
exports.FlagsFromJSON = FlagsFromJSON;
function FlagsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        requestType: json["request_type"],
        allowTemplateDelete: json["allow_template_delete"],
        allowCreateEditTemplate: json["allow_create_edit_template"],
        allowTemplatePreview: json["allow_template_preview"],
        allowOptionalTemplateSigners: json["allow_optional_template_signers"],
        smsAuthLeft: json["sms_auth_left"],
        hideProgressStepper: json["hide_progress_stepper"] == null
            ? undefined
            : json["hide_progress_stepper"],
        hideStepperContainer: json["hide_stepper_container"] == null
            ? undefined
            : json["hide_stepper_container"],
        allowIntegrationsUpload: json["allow_integrations_upload"] == null
            ? undefined
            : json["allow_integrations_upload"],
        allowRecipientAccessCodes: json["allow_recipient_access_codes"] == null
            ? undefined
            : json["allow_recipient_access_codes"],
        allowRecipientSmsAuthNumbers: json["allow_recipient_sms_auth_numbers"] == null
            ? undefined
            : json["allow_recipient_sms_auth_numbers"],
        allowRecipientAttachments: json["allow_recipient_attachments"] == null
            ? undefined
            : json["allow_recipient_attachments"],
        allowRecipientReassignment: json["allow_recipient_reassignment"] == null
            ? undefined
            : json["allow_recipient_reassignment"],
        forceSignerRoles: json["force_signer_roles"] == null
            ? undefined
            : json["force_signer_roles"],
        forceSubjectMessage: json["force_subject_message"] == null
            ? undefined
            : json["force_subject_message"],
        isAtTemplateLimit: json["is_at_template_limit"] == null
            ? undefined
            : json["is_at_template_limit"],
        maxTemplateNumber: json["max_template_number"] == null
            ? undefined
            : json["max_template_number"],
        isAtDocumentLimit: json["is_at_document_limit"] == null
            ? undefined
            : json["is_at_document_limit"],
        noMultiFaxes: json["no_multi_faxes"] == null ? undefined : json["no_multi_faxes"],
        isHelloFax: json["is_hello_fax"] == null ? undefined : json["is_hello_fax"],
        isEditTemplate: json["is_edit_template"] == null ? undefined : json["is_edit_template"],
        isResend: json["is_resend"] == null ? undefined : json["is_resend"],
        hasTemplateReuseWarning: json["has_template_reuse_warning"] == null
            ? undefined
            : json["has_template_reuse_warning"],
        requireSignerInfo: json["require_signer_info"] == null
            ? undefined
            : json["require_signer_info"],
        alwaysSendMeACopy: json["always_send_me_a_copy"] == null
            ? undefined
            : json["always_send_me_a_copy"],
        alwaysSendOthersACopy: json["always_send_others_a_copy"] == null
            ? undefined
            : json["always_send_others_a_copy"],
        integration: json["integration"] == null
            ? undefined
            : (0, Integration_1.IntegrationFromJSON)(json["integration"]),
        charge: json["charge"] == null ? undefined : (0, Charges_1.ChargesFromJSON)(json["charge"]),
        uploadIntegrations: json["upload_integrations"] == null
            ? undefined
            : (0, UploadIntegrations_1.UploadIntegrationsFromJSON)(json["upload_integrations"]),
        lockDocumentTitle: json["lock_document_title"] == null
            ? undefined
            : json["lock_document_title"],
        lockDocumentMessage: json["lock_document_message"] == null
            ? undefined
            : json["lock_document_message"],
        blockCC: json["block_CC"] == null ? undefined : json["block_CC"],
        allowUnlimitedSelfSign: json["allow_unlimited_self_sign"] == null
            ? undefined
            : json["allow_unlimited_self_sign"],
        allowExpiresAt: json["allow_expires_at"] == null ? undefined : json["allow_expires_at"],
        allowSmsAuth: json["allow_sms_auth"] == null ? undefined : json["allow_sms_auth"],
        allowBulkSend: json["allow_bulk_send"] == null ? undefined : json["allow_bulk_send"],
        allowQualifiedSignature: json["allow_qualified_signature"] == null
            ? undefined
            : json["allow_qualified_signature"],
        allowNom151: json["allow_nom_151"] == null ? undefined : json["allow_nom_151"],
        canAccessRecipientAccessCodes: json["can_access_recipient_access_codes"] == null
            ? undefined
            : json["can_access_recipient_access_codes"],
        hasHipaa: json["has_hipaa"] == null ? undefined : json["has_hipaa"],
        allowSmsSignatureDelivery: json["allow_sms_signature_delivery"] == null
            ? undefined
            : json["allow_sms_signature_delivery"],
        isSmsToolsOn: json["is_sms_tools_on"] == null ? undefined : json["is_sms_tools_on"],
        canUpgradeTierSmsSignatureDelivery: json["can_upgrade_tier_sms_signature_delivery"] == null
            ? undefined
            : json["can_upgrade_tier_sms_signature_delivery"],
        isNewHsPlan: json["is_new_hs_plan"] == null ? undefined : json["is_new_hs_plan"],
        isTransactionalPlan: json["is_transactional_plan"] == null
            ? undefined
            : json["is_transactional_plan"],
        displayDocToTemplateBanner: json["display_doc_to_template_banner"] == null
            ? undefined
            : json["display_doc_to_template_banner"],
        shouldConvertDocToTemplate: json["should_convert_doc_to_template"] == null
            ? undefined
            : json["should_convert_doc_to_template"],
        canUseDataValidation: json["can_use_data_validation"] == null
            ? undefined
            : json["can_use_data_validation"],
        canUseCustomRegexDataValidation: json["can_use_custom_regex_data_validation"] == null
            ? undefined
            : json["can_use_custom_regex_data_validation"],
        isApiUser: json["is_api_user"] == null ? undefined : json["is_api_user"],
        needsCharge: json["needs_charge"] == null ? undefined : json["needs_charge"],
        chargeType: json["charge_type"] == null ? undefined : json["charge_type"],
        totalPriceInCents: json["total_price_in_cents"] == null
            ? undefined
            : json["total_price_in_cents"],
        freeFaxPagesLeft: json["free_fax_pages_left"] == null
            ? undefined
            : json["free_fax_pages_left"],
        faxPageCurrentCount: json["fax_page_current_count"] == null
            ? undefined
            : json["fax_page_current_count"],
        overageFaxMaxLimitInCents: json["overage_fax_max_limit_in_cents"] == null
            ? undefined
            : json["overage_fax_max_limit_in_cents"],
        pricePerFaxInCents: json["price_per_fax_in_cents"] == null
            ? undefined
            : json["price_per_fax_in_cents"],
        initialPageLimit: json["initial_page_limit"] == null
            ? undefined
            : json["initial_page_limit"],
        overagePriceInCentsPerPage: json["overage_price_in_cents_per_page"] == null
            ? undefined
            : json["overage_price_in_cents_per_page"],
        internationalMultiplier: json["international_multiplier"] == null
            ? undefined
            : json["international_multiplier"],
        templateConversionCandidateId: json["template_conversion_candidate_id"] == null
            ? undefined
            : json["template_conversion_candidate_id"],
        shouldTemplateCreateShow: json["should_template_create_show"] == null
            ? undefined
            : json["should_template_create_show"],
        isFromFax: json["is_from_fax"] == null ? undefined : json["is_from_fax"],
        disableExternalSignature: json["disable_external_signature"] == null
            ? undefined
            : json["disable_external_signature"],
        shouldSendFaxPdfs: json["should_send_fax_pdfs"] == null
            ? undefined
            : json["should_send_fax_pdfs"],
        templateGalleryId: json["template_gallery_id"] == null
            ? undefined
            : json["template_gallery_id"],
        apiIdsEnabled: json["api_ids_enabled"] == null ? undefined : json["api_ids_enabled"],
        canAccessEditAndResendUI: json["can_access_edit_and_resendUI"] == null
            ? undefined
            : json["can_access_edit_and_resendUI"],
    };
}
exports.FlagsFromJSONTyped = FlagsFromJSONTyped;
function FlagsToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        request_type: value["requestType"],
        allow_template_delete: value["allowTemplateDelete"],
        allow_create_edit_template: value["allowCreateEditTemplate"],
        allow_template_preview: value["allowTemplatePreview"],
        allow_optional_template_signers: value["allowOptionalTemplateSigners"],
        sms_auth_left: value["smsAuthLeft"],
        hide_progress_stepper: value["hideProgressStepper"],
        hide_stepper_container: value["hideStepperContainer"],
        allow_integrations_upload: value["allowIntegrationsUpload"],
        allow_recipient_access_codes: value["allowRecipientAccessCodes"],
        allow_recipient_sms_auth_numbers: value["allowRecipientSmsAuthNumbers"],
        allow_recipient_attachments: value["allowRecipientAttachments"],
        allow_recipient_reassignment: value["allowRecipientReassignment"],
        force_signer_roles: value["forceSignerRoles"],
        force_subject_message: value["forceSubjectMessage"],
        is_at_template_limit: value["isAtTemplateLimit"],
        max_template_number: value["maxTemplateNumber"],
        is_at_document_limit: value["isAtDocumentLimit"],
        no_multi_faxes: value["noMultiFaxes"],
        is_hello_fax: value["isHelloFax"],
        is_edit_template: value["isEditTemplate"],
        is_resend: value["isResend"],
        has_template_reuse_warning: value["hasTemplateReuseWarning"],
        require_signer_info: value["requireSignerInfo"],
        always_send_me_a_copy: value["alwaysSendMeACopy"],
        always_send_others_a_copy: value["alwaysSendOthersACopy"],
        integration: (0, Integration_1.IntegrationToJSON)(value["integration"]),
        charge: (0, Charges_1.ChargesToJSON)(value["charge"]),
        upload_integrations: (0, UploadIntegrations_1.UploadIntegrationsToJSON)(value["uploadIntegrations"]),
        lock_document_title: value["lockDocumentTitle"],
        lock_document_message: value["lockDocumentMessage"],
        block_CC: value["blockCC"],
        allow_unlimited_self_sign: value["allowUnlimitedSelfSign"],
        allow_expires_at: value["allowExpiresAt"],
        allow_sms_auth: value["allowSmsAuth"],
        allow_bulk_send: value["allowBulkSend"],
        allow_qualified_signature: value["allowQualifiedSignature"],
        allow_nom_151: value["allowNom151"],
        can_access_recipient_access_codes: value["canAccessRecipientAccessCodes"],
        has_hipaa: value["hasHipaa"],
        allow_sms_signature_delivery: value["allowSmsSignatureDelivery"],
        is_sms_tools_on: value["isSmsToolsOn"],
        can_upgrade_tier_sms_signature_delivery: value["canUpgradeTierSmsSignatureDelivery"],
        is_new_hs_plan: value["isNewHsPlan"],
        is_transactional_plan: value["isTransactionalPlan"],
        display_doc_to_template_banner: value["displayDocToTemplateBanner"],
        should_convert_doc_to_template: value["shouldConvertDocToTemplate"],
        can_use_data_validation: value["canUseDataValidation"],
        can_use_custom_regex_data_validation: value["canUseCustomRegexDataValidation"],
        is_api_user: value["isApiUser"],
        needs_charge: value["needsCharge"],
        charge_type: value["chargeType"],
        total_price_in_cents: value["totalPriceInCents"],
        free_fax_pages_left: value["freeFaxPagesLeft"],
        fax_page_current_count: value["faxPageCurrentCount"],
        overage_fax_max_limit_in_cents: value["overageFaxMaxLimitInCents"],
        price_per_fax_in_cents: value["pricePerFaxInCents"],
        initial_page_limit: value["initialPageLimit"],
        overage_price_in_cents_per_page: value["overagePriceInCentsPerPage"],
        international_multiplier: value["internationalMultiplier"],
        template_conversion_candidate_id: value["templateConversionCandidateId"],
        should_template_create_show: value["shouldTemplateCreateShow"],
        is_from_fax: value["isFromFax"],
        disable_external_signature: value["disableExternalSignature"],
        should_send_fax_pdfs: value["shouldSendFaxPdfs"],
        template_gallery_id: value["templateGalleryId"],
        api_ids_enabled: value["apiIdsEnabled"],
        can_access_edit_and_resendUI: value["canAccessEditAndResendUI"],
    };
}
exports.FlagsToJSON = FlagsToJSON;
